import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';

const EmptyState = ({
  title = 'No data found',
  description = 'Try adjusting your filters or search query.',
  actionLabel,
  onAction,
}) => {
  return (
    <Paper
      sx={{
        p: 4,
        textAlign: 'center',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: actionLabel ? 2.5 : 0 }}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Box>
          <Button variant="contained" onClick={onAction}>
            {actionLabel}
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default EmptyState;
